import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import feedReducer from './slices/feed';
import sessionReducer from './slices/session';
import catchupReducer from './slices/catchup';
import appStateReducer from './slices/appState';
import emulatorReducer from './slices/emulator';
import { permissionsApi } from './apis/permissions.api';

export const store = configureStore({
  reducer: {
    feed: feedReducer,
    catchup: catchupReducer,
    session: sessionReducer,
    appState: appStateReducer,
    emulator: emulatorReducer,
    [permissionsApi.reducerPath]: permissionsApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(permissionsApi.middleware),
});

setupListeners(store.dispatch);
